import { useState } from 'react';

import { useAtom } from 'jotai';
import { useRouter } from 'next/router';

import {
  ChangePasswordService,
  SendOtp,
  VerifyOtpService,
} from '@/api/fetch/auth-service';
import { getUserbyphone } from '@/api/fetch/marketplace-api';
import {
  ChangePasswordRequestGRPC,
  SendOtpRequest,
  VerifyOtpRequestGRPC,
} from '@/api/gen-protos/auth_pb';
import { UserByPhoneNumberRequest } from '@/api/gen-protos/users_pb';
import {
  ForgetPasswordIdentifiantAtom,
  pageLoading,
  PageLoadingAction,
} from '@/lib/store';

type FirstLoggedObject = {
  kcid: string;
  loggedinaftercutoff: boolean;
  phonenumber: string;
  username: string;
};

const useForgetPasswordHook = () => {
  const router = useRouter();

  // const [loading, setloading] = useState(false);
  const [loggedUserData] = useAtom<FirstLoggedObject>(
    ForgetPasswordIdentifiantAtom
  );

  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setnewPassword] = useState('');
  const [newRePassword, setnewRePassword] = useState('');
  const [error, setError] = useState<any>({});

  const [, setIsLoading] = useAtom(pageLoading);

  const udpdateError = (errorKey: string, message: string) => {
    setError({
      ...error,
      [errorKey]: message,
    });
  };

  const sendOtpSms = async () => {
    setIsLoading(PageLoadingAction.Start);

    if (loggedUserData.phonenumber) {
      const sendOtpRequest = new SendOtpRequest();
      sendOtpRequest.setPhonenumber(loggedUserData.phonenumber);
      await SendOtp(sendOtpRequest).then((res) => {
        if (res.getMessage() === 'Otp Send Successfully') {
          router.push({
            query: {
              ...router.query,
              screen: 'sms',
            },
          });
        }
      });
    }

    setIsLoading(PageLoadingAction.Stop);
  };

  const verifyUserByPhone = () => {
    setIsLoading(PageLoadingAction.Start);

    const userBynationalNumberRequest = new UserByPhoneNumberRequest();
    userBynationalNumberRequest.setPhonenumber(loggedUserData.phonenumber);

    getUserbyphone(userBynationalNumberRequest)
      .then((UserResponse) => {
        if (UserResponse)
          udpdateError(
            'new-user',
            'Ce numéro est déjà utilisé par un autre utilisateur'
          );
        setIsLoading(PageLoadingAction.Stop);
      })
      .catch((error1) => {
        if (error1 === 'mongo: no documents in result') {
          sendOtpSms();
        }
        setIsLoading(PageLoadingAction.Stop);
      });
  };

  const VerifyOtpSms = async () => {
    setIsLoading(PageLoadingAction.Start);

    if (verificationCode.length === 6 && loggedUserData.phonenumber) {
      udpdateError('verify-otp', '');
      const verifyRequest = new VerifyOtpRequestGRPC();
      verifyRequest.setPhonenumber(loggedUserData.phonenumber.toString());
      verifyRequest.setOtp(verificationCode.toString());
      await VerifyOtpService(verifyRequest).then(
        (r) => {
          if (r.getMessage() === 'WRONG OTP') {
            udpdateError('sms', 'code de vérification invalide');
            return;
          }
          router.push({
            query: {
              ...router.query,
              screen: 'new-password',
            },
          });
        },
        (_) => {
          udpdateError('sms', 'code de vérification invalide');
        }
      );
    } else {
      udpdateError('sms', 'code verification must contains 6 number');
    }

    setIsLoading(PageLoadingAction.Stop);
  };
  const updatePassword = async () => {
    if (!newPassword || !newRePassword || newPassword !== newRePassword) {
      udpdateError('new-password', 'vérifier les mots de passe');
      return;
    }
    setIsLoading(PageLoadingAction.Start);

    if (
      loggedUserData?.phonenumber &&
      newPassword &&
      newRePassword &&
      newPassword === newRePassword
    ) {
      const changePasswordRequest = new ChangePasswordRequestGRPC();
      changePasswordRequest.setPassword(newPassword);
      changePasswordRequest.setUserid(loggedUserData.kcid);
      ChangePasswordService(changePasswordRequest).then(
        (_) => {
          router.replace({
            pathname: (router.query.returnUrl as string) || '/',
          });
        },
        (reason) => {
          udpdateError('new-password', reason);
        }
      );
    } else {
      udpdateError('new-password', 'vérifier les mots de passe');
    }

    setIsLoading(PageLoadingAction.Stop);
  };

  return {
    verificationCode,
    setVerificationCode,
    error,
    setError,
    sendOtpSms,
    VerifyOtpSms,
    verifyUserByPhone,
    newPassword,
    setnewPassword,
    newRePassword,
    setnewRePassword,
    updatePassword,
    loggedUserData,
  };
};

export default useForgetPasswordHook;
